import { render, staticRenderFns } from "./ConstructionTypes.vue?vue&type=template&id=3f3b91a6&scoped=true"
import script from "./ConstructionTypes.vue?vue&type=script&lang=js"
export * from "./ConstructionTypes.vue?vue&type=script&lang=js"
import style0 from "./ConstructionTypes.vue?vue&type=style&index=0&id=3f3b91a6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3b91a6",
  null
  
)

export default component.exports